import React, { useState } from 'react';

import { Button, Input } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const INITIAL = {
	name: ''
};

const Warrants = ({ grade }) => {
	// Store warrant's data
	const [data, setData] = useState(INITIAL);

	// Use user's creation store
	const onAddStudentWarrant = useUserCreateStore(state => state.onAddStudentWarrant);

	// Handle warrant data change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handle warrant addition for student
	const onAdd = () => {
		// Reset warrant's data
		setData(INITIAL);

		// Add warrant to student's data
		onAddStudentWarrant(grade.id, data);
	};

	return (
		<>
			<div className="flex flex-col items-end space-y-4">
				<Input
					type="text"
					name="name"
					label="Rīkojuma nosaukums"
					className="w-full"
					value={data.name}
					onChange={onChange}
				/>
						
				<Button
					icon="check"
					theme="success"
					value="Pievienot"
					onClick={onAdd}
					disabled={data.name === ''}
				/>
			</div>
		</>
	);
};

export default Warrants;